import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { NOTIF_TYPES } from '@private/notifications';
import { useQuery } from '@tanstack/react-query';

import api from 'api';
import { DATA_KEYS } from 'api/data/constants';
import { notificationService } from 'utils/notificationService';
import { QueryError } from 'utils/types';

import { normalizeQueryKey } from '../utils';

export const useGetDictionaries = () => {
  return useQuery({
    gcTime: Infinity,
    queryFn: api.data.getDictionaries,
    queryKey: normalizeQueryKey([DATA_KEYS.DICTIONARIES]),
    staleTime: 60 * 60 * 1000,
  });
};

export const useGetAnalyticsDictionaries = (enabled = true) => {
  const { t } = useTranslation();

  const query = useQuery({
    enabled,
    gcTime: Infinity,
    queryFn: api.data.getAnalyticsDictionaries,
    queryKey: normalizeQueryKey([DATA_KEYS.ANALYTIC_DICTIONARIES]),
    staleTime: 60 * 60 * 1000,
    throwOnError: false,
  });

  useEffect(() => {
    if (query.isError) {
      const error = query.error as QueryError;
      notificationService.show({
        message: error?.response?.data?.message,
        title: t('notifications.errorTitle'),
        type: NOTIF_TYPES.ERROR,
      });
    }
  }, [query.error, query.isError, t]);

  return query;
};

export const useGetAuthDictionaries = (enabled = true) => {
  const { t } = useTranslation();

  const query = useQuery({
    enabled,
    gcTime: Infinity,
    queryFn: api.data.getAuthDictionaries,
    queryKey: [DATA_KEYS.AUTH_DICTIONARIES],
    staleTime: 60 * 60 * 1000,
    throwOnError: false,
  });

  useEffect(() => {
    if (query.isError) {
      const error = query.error as QueryError;
      notificationService.show({
        message: error?.response?.data?.message,
        title: t('notifications.errorTitle'),
        type: NOTIF_TYPES.ERROR,
      });
    }
  }, [query.error, query.isError, t]);

  return query;
};

export const useGetBuilderDictionaries = (enabled = true) => {
  const { t } = useTranslation();

  const query = useQuery({
    enabled,
    gcTime: Infinity,
    queryFn: api.data.getBuilderDictionaries,
    queryKey: [DATA_KEYS.BUILDER_DICTIONARIES],
    staleTime: 60 * 60 * 1000,
    throwOnError: false,
  });

  useEffect(() => {
    if (query.isError) {
      const error = query.error as QueryError;
      notificationService.show({
        message: error?.response?.data?.message,
        title: t('notifications.errorTitle'),
        type: NOTIF_TYPES.ERROR,
      });
    }
  }, [query.error, query.isError, t]);

  return query;
};
